import {doTo} from './promise'
import {sortBy} from 'remeda'

export const avgOf = <T>(items: T[], by: (i: T) => number) => sumOf(items, by) / items.length
export const sumOf = <T>(items: T[], by: (i: T) => number) => items.map(by).reduce((p, c) => p + c, 0)
export const medianOf = <T>(items: T[], by: (i: T) => number = (i: T) => i as number) => {
  if (items.length == 0) return null
  const sorted = sortBy(items, by)
  var half = Math.floor(sorted.length / 2)
  const res = sorted.length % 2 ? by(sorted[half]!) : (by(sorted[half - 1]!) + by(sorted[half]!)) / 2.0
  return res
}

export const geomOfWholePct = <T>(items: T[], by: (i: T) => number = (i: T) => i as number) =>
  items?.length
    ? oddsToWholePct(
        geometricMean(
          items
            .map(by)
            .filter(v => v != null)
            .map(wholePctToOdds)
        )
      )
    : undefined

/** converts a percentage (in the form 0-100) into odds. If 100% then considered to be 1million odds  */
export const wholePctToOdds = (pct: number) =>
  pct == 0 ? 0 : doTo((0.01 * pct) / (1 - 0.01 * pct), odds => (odds == Number.POSITIVE_INFINITY ? 1000000 : odds))

export const oddsToWholePct = (odds: number) => (odds == 0 ? 0 : (100 * odds) / (1 + odds))

export const geometricMean = <T>(data: T[], getOdds = (d: T) => d as number) => {
  const r = 64
  const K = 2 ** r
  const K1 = 2 ** -r
  let p = 1 // product
  let n = 0 // count
  let s = 1 // sign
  let k = 0 // track exponent to prevent under/overflows

  data.map(getOdds).forEach(v => {
    if (v == Number.POSITIVE_INFINITY) throw Error('Infinity')
    n++
    s = Math.sign(v)
    if (s === 0) return 0
    p *= Math.abs(v)
    while (p > K) (p *= K1), ++k
    while (p < K1) (p *= K), --k
  })
  return n ? s * 2 ** ((Math.log2(p) + k * r) / n) : NaN
}

export type Dir = 'asc' | 'desc'
export function firstBy<T>(items: T[], by: (i: T) => number, dir: Dir) {
  let [first, v] = [null as T, null as number | null]
  items.forEach(i => {
    const n = by(i)
    if (v == null || (dir == 'desc' ? n > v : n < v)) [first, v] = [i, n]
  })
  return first
}
export const min = (items: number[]) => firstBy(items, i => i, 'asc')
export const max = (items: number[]) => firstBy(items, i => i, 'desc')
export const sum = (items: number[]) => items.reduce((p, c) => p + c, 0)
